import factories from '../generics/factories'
const { factory, createMixin, fetchMixin, patchMixin, deleteMixin } = factories

const store = factory(
  {
    entityName: 'Carrier',
    urlTemplate: id => id ? `logistics/carriers/${id}/` : `logistics/carriers/`
  },
  createMixin,
  fetchMixin,
  patchMixin,
  deleteMixin
)

export default store
